export const isUpperCase = char => /[A-Z]{1}/.test(char);
